// extracted by mini-css-extract-plugin
export default {"loader":"SpinLoader_loader__GuhNe","rotation":"SpinLoader_rotation__WkCoC","spinLoader":"SpinLoader_spinLoader__NslTy"};